import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { connect } from "react-redux";
import style from "./list.module.sass";
import { Http } from "../../../../helpers/axois";
import { pushToast } from "../../../../stateManager/store/toast/actions";
import { setStepIndex, setGuideVisible, setOnboardingAppDetails } from "../../../../stateManager/store/onboarding/action";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

interface State {
  serviceName?: string;
  displayName?: string;
  displayNameErr?: string;
  serviceNameErr: string;
  langauge?: string;
  selectedJourney?: any;
}

interface Props {
  onSubmit: (submit: () => void) => void;
  appId?: any;
  versionId?: any;
  getService: (res: any) => void;
  editInitialData?: any;
  editable?: boolean;
  setvisible?: (visible: boolean) => void;
  pushToast?: (data: any) => void;
  currentBranch?: any;
  selectedService?: any;
  editType: string;
  onboardingInfo: any;
  userName: any;
  setStepIndex?: any;
  setGuideVisible?: any;
  setOnboardingAppDetails?: any;
}

class AppService extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      serviceName: this.props.editInitialData && this.props.editInitialData.name ? this.props.editInitialData.name : "",
      displayName: this.props.editInitialData && this.props.editInitialData.displayName ? this.props.editInitialData.displayName : "",
      displayNameErr: "",
      serviceNameErr: "",
      langauge: this.props.editInitialData && this.props.editInitialData.lang ? this.props.editInitialData.lang : "javascript",
    };
    this.props.onSubmit(this.onSubmit);
  }

  onSubmit = () => {
    if ((this.state.serviceName && this.state.displayName)) {
      let { editable, editInitialData } = this.props;
      if (!editable) {
        this.saveService();
      } else {
        this.updateService(editInitialData.id);
      }
    } else {
      this.setState({ serviceNameErr: "required" });
      this.setState({ displayNameErr: "required" });
    }
  };

  saveService() {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    const data = {
      name: this.state.serviceName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      versionId: this.props.versionId,
      lang: this.state.langauge,
      topicName: this.state.serviceName,
      branchId: currentBranchId
    };
    const { getService, setvisible } = this.props;
    const { guideVisible, info } = this.props.onboardingInfo;
    const stepIndex = info.stepIndex;
    guideVisible && this.props.setStepIndex(stepIndex + 1)
    setvisible && setvisible(false); 
    Http.post("services", data).subscribe(
      (res: any) => {
        if (guideVisible && res.length) {
          const payload = {
            ...info,
            stepIndex: stepIndex + 1,
            serviceId: res[0].service_id
          }
          this.props.setOnboardingAppDetails(payload)
        }
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Service saved successfully" });
        getService(res);
      },
      (err) => {
        if (err && err.code === "23505") {
          this.props.pushToast && this.props.pushToast({ type: "error", message: "Service name already Exists" });
        } else {
          this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Service save failed" });
        }
        setvisible && setvisible(false);
      }
    );
  }


  updateService(serviceId?: string) {
    const { getService, setvisible } = this.props;

    const data = {
      name: this.state.serviceName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      versionId: this.props.versionId
    };
    Http.put(`/services/${serviceId}`, data).subscribe(
      (res) => {
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Service updated successfully" });
        getService(res);
        setvisible && setvisible(false);
      },
      (err) => {
        this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Service Updation failed" });
        setvisible && setvisible(false);
      }
    );
  }


  render() {
    let { editInitialData } = this.props;
    let { serviceNameErr, displayNameErr } = this.state;
    const languageDisable = editInitialData ? true : false;
    return (
      <div>
        {<Form {...formItemLayout} className={style.app + " override-content"}>
          <Form.Item
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            className="service_creation_displayname"
            label={<span className={style.labelName}>Display Name</span>}
          >
            <Input
              data-test-id="service_display_name"
              defaultValue={editInitialData && editInitialData.displayName}
              value={this.state.displayName}
              onKeyDown={
                (e: React.KeyboardEvent) => {
                   if(this.props.onboardingInfo.guideVisible && e.key === 'Tab') {
                    e.preventDefault()
                  }
              }} 
              onChange={(e) => {
                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                                ;
                if (e.target.value === '' || re.test(e.target.value)) {
                  let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                  let value =  val.replace(/ /g,"_") 
                this.setState({ displayName: e.target.value,serviceName: languageDisable? this.state.serviceName:value, displayNameErr: "" })}}
              }
            />
          </Form.Item>
          <Form.Item
            validateStatus={serviceNameErr && "error"}
            help={serviceNameErr}
            label={<span className={style.labelName}>Name(identifier)</span>}
          >
            <Input
              data-test-id="service_name"
              disabled={languageDisable}
              defaultValue={editInitialData && editInitialData.name}
              value={this.state.serviceName}
              onChange={(e) =>{
                const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                 this.setState({ serviceName: e.target.value.trim().replace(/ /g, "_"), serviceNameErr: "" })}}}
            />
          </Form.Item>
          <Form.Item className="service_creation_language" label={<span className={style.labelName}>Language</span>}>
            <Select data-test-id="service_language" disabled={languageDisable} value={this.state.langauge} onChange={(e: any) => this.setState({ langauge: e })}>
              <Option data-test-id="service_javascript" value="javascript">JavaScript</Option>
              <Option data-test-id="service_typescript" value="typescript">TypeScript</Option>
            </Select>
          </Form.Item>
        </Form>}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentBranch: state.apps.appBranch,
    selectedService: state.solo.selectedService,
    onboardingInfo: state.onboarding,
    userName: state.user.data.user.userName
  }
}

export default connect(mapStateToProps, { pushToast, setStepIndex, setGuideVisible, setOnboardingAppDetails })(AppService);
